import {
  Box,
  Button,
  Image,
  ListItem,
  Stack,
  Text,
  UnorderedList,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { NavLink, Link } from "react-router-dom";
import { Icon, Img } from "../../../content/Content";
import "./sideNav.component.css";

const SideNav = () => {
  const Menu = [
    {
      name: "Dashboard",
      icon: Icon.dashboard,
      url: "dashboard",
    },
    {
      name: "Travel",
      icon: Icon.airplane,
      url: "travel",
    },
    {
      name: "Health",
      icon: Icon.health,
      url: "health",
    },
    {
      name: "University",
      icon: Icon.education,
      url: "university",
    },
    {
      name: "Live",
      icon: Icon.graph,
      url: "live",
      live: true,
    },
    {
      name: "Chart Ideas",
      icon: Icon.homeTrend,
      url: "chart-ideas",
    },   
     {
      name: "Announcements",
      icon: Icon.Announcements,
      url: "announcements",
    },  
     {
      name: "Chat",
      icon: Icon.Announcements,
      url: "chat",
    },
    {
      name: "Team",
      icon: Icon.group_people,
      url: "team",
    },
    {
      name: "Profile",
      icon: Icon.user,
      url: "profile",
    },
  ];

  return (
    <VStack
      bg="rgba(0, 0, 0, 1)"
      minH="100vh"
      maxH="100%"
      py="30px"
      alignItems="center"
      justifyContent="flex-start"
      position={'fixed'}
      left='0'
      className="side-nav"
    >
      {/* Logo-area */}
      <Stack w="100%">
        <Box>
          <Link to="">
            <Image src={Img.acdemyLogo} w="140px" mx="auto" />
          </Link>
        </Box>
      </Stack>
      {/* navbar-area */}
      <Stack pt="35px">
        <Box>
          <UnorderedList pe="20px">
            {Menu.map((item) => (
              <ListItem listStyleType="none" my="10px">
                <NavLink
                  to={item.url}
                  className={({ isActive, isPending }) =>
                    isPending ? "pending" : isActive ? "active" : ""
                  }
                >
                  <Box
                    className="nav-item"
                    display="flex"
                    alignItems="center"
                    p="8px 25px"
                    borderRadius="12px"
                  >
                    <Image src={item.icon} />
                    <Text
                      mx="8px"
                      fontFamily="'Roboto', sans-serif"
                      fontWeight="500"
                      fontSize={"20px"}
                      color="#fff"
                    >
                      {item.name}
                    </Text>
                    {item.live ? (
                      <Button w="36px" h="20px" bg="rgba(240, 240, 250, 1)">
                        5
                      </Button>
                    ) : (
                      ""
                    )}
                  </Box>
                </NavLink>
              </ListItem>
            ))}
          </UnorderedList>
        </Box>
      </Stack>
    </VStack>
  );
};

export default SideNav;
